import {Record, List} from 'immutable';

import {
  defaultActionConfigTarget,
  defaultMoveAction,
  defaultScaleAction,
  defaultRotateAction,
  defaultSkewAction,
  defaultOpacityAction,
  defaultFilterAction,
  defaultBackgroundColorAction,
  defaultBorderColorAction,
  defaultTextColorAction,
  defaultSizeAction,
  defaultHideShowAction,
  defaultPluginLottieAction,
  defaultPluginSplineAction,
  defaultPluginRiveAction,
  defaultFilterItemConfig,
  defaultFontVariationItemConfig,
} from '@packages/systems/ix2/designer/records/pojo';

import type {FontVariationItemConfigType} from '@packages/systems/ix2/types-core';

// @ts-expect-error - TS2322 - Type 'Factory<{ styleBlockIds: List<string>; pluginElement?: string | undefined; objectId?: string | undefined; nodeId: string | null; appliesTo: "ELEMENT" | "ELEMENT_CLASS" | "TRIGGER_ELEMENT"; useEventTarget: boolean | ... 3 more ... | undefined; boundaryMode: boolean; }>' is not assignable to type 'Factory<ActionItemTargetType>'.
export const ActionConfigTargetRecord: Record.Factory<
  typeof defaultActionConfigTarget
> = Record(
  {...defaultActionConfigTarget, styleBlockIds: List()},
  'ActionConfigTargetRecord'
);

const createActionRecord: <Action, Config>(
  arg1: Action,
  arg2: Config,
  arg3: string
  // @ts-expect-error - TS2344 - Type 'Action & Config' does not satisfy the constraint 'object'.
) => Record.Factory<Action & Config> = (action, config, name) =>
  // @ts-expect-error - TS2322 - Type 'Factory<Action & { config: Record<Config & { target: Record<ActionItemTargetType> & Readonly<ActionItemTargetType>; }> & Readonly<...>; }>' is not assignable to type 'Factory<Action & Config>'.
  Record(
    {
      ...action,
      config: Record(
        {...config, target: ActionConfigTargetRecord()},
        `${name}Config`
      )(),
    },
    name
  );

export const MoveActionRecord = createActionRecord(
  defaultMoveAction,
  defaultMoveAction.config,
  'MoveActionRecord'
);

export const ScaleActionRecord = createActionRecord(
  defaultScaleAction,
  defaultScaleAction.config,
  'ScaleActionRecord'
);
export const RotateActionRecord = createActionRecord(
  defaultRotateAction,
  defaultRotateAction.config,
  'RotateActionRecord'
);
export const SkewActionRecord = createActionRecord(
  defaultSkewAction,
  defaultSkewAction.config,
  'SkewActionRecord'
);
export const OpacityActionRecord = createActionRecord(
  defaultOpacityAction,
  defaultOpacityAction.config,
  'OpacityActionRecord'
);
export const FilterActionRecord = createActionRecord(
  defaultFilterAction,
  defaultFilterAction.config,
  'FilterActionRecord'
);
export const BackgroundColorActionRecord = createActionRecord(
  defaultBackgroundColorAction,
  defaultBackgroundColorAction.config,
  'BackgroundColorActionRecord'
);
export const BorderColorActionRecord = createActionRecord(
  defaultBorderColorAction,
  defaultBorderColorAction.config,
  'BorderColorActionRecord'
);
export const TextColorActionRecord = createActionRecord(
  defaultTextColorAction,
  defaultTextColorAction.config,
  'TextColorActionRecord'
);
export const SizeActionRecord = createActionRecord(
  defaultSizeAction,
  defaultSizeAction.config,
  'SizeActionRecord'
);
export const HideShowActionRecord = createActionRecord(
  defaultHideShowAction,
  defaultHideShowAction.config,
  'HideShowActionRecord'
);
export const PluginLottieActionRecord = createActionRecord(
  defaultPluginLottieAction,
  defaultPluginLottieAction.config,
  'PluginLottieActionRecord'
);

export const PluginSplineActionRecord = createActionRecord(
  defaultPluginSplineAction,
  defaultPluginSplineAction.config,
  'PluginSplineActionRecord'
);

export const PluginRiveActionRecord = createActionRecord(
  defaultPluginRiveAction,
  defaultPluginRiveAction.config,
  'PluginRiveActionRecord'
);

export type ActionItemRecordType =
  | ReturnType<typeof MoveActionRecord>
  | ReturnType<typeof ScaleActionRecord>
  | ReturnType<typeof RotateActionRecord>
  | ReturnType<typeof SkewActionRecord>
  | ReturnType<typeof OpacityActionRecord>
  | ReturnType<typeof FilterActionRecord>
  | ReturnType<typeof BackgroundColorActionRecord>
  | ReturnType<typeof BorderColorActionRecord>
  | ReturnType<typeof TextColorActionRecord>
  | ReturnType<typeof SizeActionRecord>
  | ReturnType<typeof HideShowActionRecord>
  | ReturnType<typeof PluginLottieActionRecord>
  | ReturnType<typeof PluginSplineActionRecord>
  | ReturnType<typeof PluginRiveActionRecord>;

export type ActionItemsRecordType = List<ActionItemRecordType>;

export const FilterItemConfigRecord = Record(
  defaultFilterItemConfig,
  'FilterItemConfigRecord'
);

export const FontVariationItemConfigRecord: Record.Factory<FontVariationItemConfigType> =
  Record(defaultFontVariationItemConfig, 'FontVariationItemConfigRecord');

export const ActionRecords = {
  [defaultMoveAction.actionTypeId]: MoveActionRecord,
  [defaultScaleAction.actionTypeId]: ScaleActionRecord,
  [defaultRotateAction.actionTypeId]: RotateActionRecord,
  [defaultSkewAction.actionTypeId]: SkewActionRecord,
  [defaultOpacityAction.actionTypeId]: OpacityActionRecord,
  [defaultFilterAction.actionTypeId]: FilterActionRecord,
  [defaultBackgroundColorAction.actionTypeId]: BackgroundColorActionRecord,
  [defaultBorderColorAction.actionTypeId]: BorderColorActionRecord,
  [defaultTextColorAction.actionTypeId]: TextColorActionRecord,
  [defaultSizeAction.actionTypeId]: SizeActionRecord,
  [defaultHideShowAction.actionTypeId]: HideShowActionRecord,
  [defaultPluginLottieAction.actionTypeId]: PluginLottieActionRecord,
  [defaultPluginSplineAction.actionTypeId]: PluginSplineActionRecord,
  [defaultPluginRiveAction.actionTypeId]: PluginRiveActionRecord,
} as const;
